import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Alert, Button, MenuItem, Modal, Snackbar, Tab, TableHead, TextField, useTheme } from "@mui/material";
import { primarycolor, columncolor } from "../../../utils/colors";
import axios from "axios";
import Select from 'react-select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import Menu from '@mui/material/Menu';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { checknumber, formatDate, getissuecolor, handleMenuItemClick } from "../../../utils/functions";
import { ArrowOutwardOutlined, Save, ShoppingBasket } from "@mui/icons-material";
import { Adminfetchconversationsurl, Changeconvostatusurl, Fetchaccountsurl } from "../../../utils/chaturls";
import { getsessionuser } from "../../../utils/sessions";
import Loadingspinner from "../../../components/Loadingspinner";
import { convooptionsarray } from "../../../utils/arrays";
import { Erroralert, Successalert } from "../../../components/popups";
import Clientmessages from "./messages";
import Popupdialog from "../../../components/popupdialog";

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}



const tableheadstyle = {
    color: "white",
    fontWeight: "bold"
}




const Conversations = ({ messagecounter }) => {
    const user = getsessionuser()
    const [role, setrole] = React.useState('');
    const [loading, setloading] = useState(false);
    const [refreshdata, setrefreshdata] = useState('');

    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');

    const [conversations, setconversations] = useState([]);
    const [displayedconversations, setdisplayedconversations] = useState([]);
    const [agents, setagents] = useState([]);
    const [pendingissues, setpendingissues] = useState('');
    const [completedissues, setcompletedissues] = useState('');

    const [agenttoassign, setagenttoassign] = useState('');

    const [iteminplay, setiteminplay] = useState('');


    const [nodata, setnodata] = useState(false);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    //search states
    const [ticket, setticket] = useState('');
    const [convostatus, setconvostatus] = useState('');

    //modals
    const [showassignagent, setshowassignagent] = useState(false);
    const [showmarkissue, setshowmarkissue] = useState(false);



    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - displayedconversations.length) : 0;

    const handleChangePage = (event, newPage,) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        fetchdata();
    }, [refreshdata]);

    useEffect(() => {
        fetchsilentdata();
    }, [messagecounter]);


    const fetchdata = async () => {
        try {
            setnodata(false);
            setloading(true);
            const [conversationsResponse, agentsResponse] = await Promise.all([
                axios.post(Adminfetchconversationsurl),
                axios.post(Fetchaccountsurl)
            ]);

            setloading(false);
            // Handle Conversations Response
            if (!conversationsResponse.data.error) {
                const conversationsData = conversationsResponse.data.reverse();
                if (conversationsData.length > 0) {
                    setconversations(conversationsData);
                    setdisplayedconversations(conversationsData);
                    //sort
                    setcompletedissues(conversationsData.filter((obj) => obj.status === 'completed').length)
                    setpendingissues(conversationsData.filter((obj) => obj.status === 'pending').length)
                } else {
                    setnodata(true);
                }
            } else {
                seterror(conversationsResponse.data.message);
            }

            // Handle Agents Response
            if (!agentsResponse.data.error) {
                const agentsData = agentsResponse.data.map((val) => ({
                    label: val.username,
                    value: val.id
                }));
                setagents(agentsData);
            }
        } catch (error) {
            setloading(false);
            seterror('Sorry an error occurred, try again later');
            // Handle specific error response statuses if needed
        }
    };

    const fetchsilentdata = async () => {
        try {
            const [conversationsResponse, agentsResponse] = await Promise.all([
                axios.post(Adminfetchconversationsurl),
                axios.post(Fetchaccountsurl)
            ]);
            if (!conversationsResponse.data.error) {
                const conversationsData = conversationsResponse.data.reverse();
                if (conversationsData.length > 0) {
                    setconversations(conversationsData);
                    setdisplayedconversations(conversationsData);
                    //sort
                    setcompletedissues(conversationsData.filter((obj) => obj.status === 'completed').length)
                    setpendingissues(conversationsData.filter((obj) => obj.status === 'pending').length)
                } else {
                    setnodata(true);
                }
            }
            // Handle Agents Response
            if (!agentsResponse.data.error) {
                const agentsData = agentsResponse.data.map((val) => ({
                    label: val.username,
                    value: val.id
                }));
                setagents(agentsData);
            }
        } catch (error) {

        }
    }

    const assignagent = async () => {
        setshowassignagent(false);
        setloading(true);
        try {
            const response = await axios.put(Changeconvostatusurl, {
                agentid: agenttoassign.value ? agenttoassign.value : iteminplay.agentid,
                convoid: iteminplay.id,
                convostatus: 'active',
                agentstatus: '0'
            });
            setloading(false);
            if (!response.data.error) {
                setsuccess('Updated successfully');
                setTimeout(() => {
                    setsuccess();
                    fetchdata();
                }, 3000);
            } else {
                seterror(response.data.message);
            }
        } catch (error) {
            setloading(false);
            seterror('Sorry an error occurred, try again later');
        }
    };

    //mark as done
    const markissue = async () => {
        setshowmarkissue(false);
        setloading(true);
        try {
            const response = await axios.put(Changeconvostatusurl, {
                agentid: agenttoassign.value,
                convoid: iteminplay.id,
                convostatus: 'completed',
                agentstatus: '1'
            });
            setloading(false);
            if (!response.data.error) {
                setsuccess('Updated successfully');
                setTimeout(() => {
                    setsuccess();
                    fetchdata();
                }, 3000);
            } else {
                seterror(response.data.message);
            }
        } catch (error) {
            setloading(false);
            seterror('Sorry an error occurred, try again later');
        }
    }




    //styles
    const textinputstyles = {
        maxHeight: 20,
        marginRight: 5,
        width: 200,
        marginBottom: 5,
        fontSize: 13
    }


    //search conversations
    const searchconversations = (ticket) => {
        if (!ticket) {
            setdisplayedconversations(conversations)
        } else {
            const gottendata = conversations.filter((obj) => obj.ticket === ticket)
            if (gottendata.length > 0) {
                setdisplayedconversations(gottendata)
            } else {
                setdisplayedconversations([])
                seterror("no conversations matches the search query")
            }
        }
    }


    //change convo status
    const changeconvo = (status) => {
        if (!status) {
            setdisplayedconversations(conversations)
        } else {
            setdisplayedconversations(conversations.filter((obj) => obj.status === status))
        }
        setconvostatus(status)

    }



    return (
        <div>
            {error?.length > 0 && <Erroralert onClose={() => seterror()} message={error} />}
            {success?.length > 0 && <Successalert onClose={() => setsuccess()} message={success} />}
            {loading && <Loadingspinner />}
            <Modal
                open={showassignagent}
                onClose={() => setshowassignagent(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Container sx={{
                    backgroundColor: "white",
                    marginTop: 5,
                    padding: 4,
                    borderRadius: 5
                }} maxWidth="sm">
                    <div style={{ color: "gray", fontWeight: 800, fontSize: 16 }}>Assign conversation to; </div>
                    <div>
                        Agents:<br />
                        <div >
                            <Select required menuPlacement="bottom" options={agents} onChange={e => setagenttoassign(e)}  ></Select>
                        </div><br />
                    </div><br /><br />
                    <Button disabled={!agenttoassign && true} startIcon={<Save />} onClick={() => assignagent()} variant="outlined">Save</Button>
                </Container>
            </Modal>
            {showmarkissue &&
                <Popupdialog
                    toptext={"Confirm Completion!"}
                    question={"Are you sure you want to mark issue as completed?"}
                    oncancel={() => setshowmarkissue(false)}
                    onsuccess={markissue}
                    successtext={"Complete"} />
            }
            <div className="routepathwrap">
                <div className="routepathmain">Conversations</div>
                <div className="routepathminor"> / All conversations</div>
            </div>
            <Container maxWidth="lg" className="containerwithshadow" style={{ marginTop: 10 }}>
                <div className="wrapmoddivs">
                    <div className="wrapandivs">
                        <div className="slimdiv1" />
                        <div className="andivright">
                            <div className="andivrightdiv">
                                <div className="andivrighttext">ALL ISSUES</div>
                                <div className="andivrightpercent">
                                    <ArrowOutwardOutlined /> + 100%
                                </div>
                            </div><br />
                            <div className="andivrightdiv">
                                <div className="andivrightnumber">{conversations.length}</div>
                                <div className="shoppingiconprimary">
                                    <ShoppingBasket sx={{ color: "white", fontSize: 15 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapandivs">
                        <div className="slimdiv2" />
                        <div className="andivright">
                            <div className="andivrightdiv">
                                <div className="andivrighttext">PENDING ISSUES</div>
                                <div className="andivrightpercent2">
                                    <ArrowOutwardOutlined /> %
                                </div>
                            </div><br />
                            <div className="andivrightdiv">
                                <div className="andivrightnumber">{pendingissues}</div>
                                <div className="shoppingiconprimary2">
                                    <ShoppingBasket sx={{ color: "white", fontSize: 15 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapandivs">
                        <div className="slimdiv3" />
                        <div className="andivright">
                            <div className="andivrightdiv">
                                <div className="andivrighttext">SORTED ISSUES</div>
                                <div className="andivrightpercent3">
                                    <ArrowOutwardOutlined />
                                </div>
                            </div><br />
                            <div className="andivrightdiv">
                                <div className="andivrightnumber">{completedissues}</div>
                                <div className="shoppingiconprimary3">
                                    <ShoppingBasket sx={{ color: "white", fontSize: 15 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
            <Container maxWidth="lg" className="containerwithshadow" style={{ marginTop: 20 }}>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    <TextField id="outlined-basic" sx={textinputstyles} label="Ticket ID" variant="outlined" size="small" value={ticket} onChange={(e) => setticket(e.target.value)} />
                    <div style={textinputstyles}>
                        <Select menuPlacement="bottom" options={convooptionsarray} onChange={e => changeconvo(e.value)}  ></Select>
                    </div>&nbsp;&nbsp;&nbsp;
                    <Button variant="contained" onClick={() => searchconversations()} sx={{ background: primarycolor, height: 40, marginRight: 3 }}>Search</Button>
                </div>
            </Container>
            <Container maxWidth="lg" className="containerwith" style={{ marginTop: 20 }}>
                <div className="tablecontainer" >
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="custom pagination table">
                            <TableHead sx={{ backgroundColor: primarycolor }}>
                                <TableRow>
                                    <TableCell sx={tableheadstyle} >Convo Id</TableCell>
                                    <TableCell sx={tableheadstyle}>Ticket </TableCell>
                                    <TableCell sx={tableheadstyle}>Agent </TableCell>
                                    <TableCell sx={tableheadstyle}>status </TableCell>
                                    <TableCell sx={tableheadstyle} >Date Created </TableCell>
                                    <TableCell sx={tableheadstyle} >Messages</TableCell>
                                    <TableCell sx={tableheadstyle} >Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(rowsPerPage > 0
                                    ? Array.isArray(displayedconversations) && displayedconversations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    : displayedconversations
                                ).map((row, key) => {
                                    const messages = row.messages;
                                    const unread = (messages.filter((obj) => obj.readstatus === 0)).length;

                                    return (
                                        <TableRow key={key} style={{ background: checknumber(key) ? columncolor : "white" }}>
                                            <TableCell component="th" scope="row" sx={{ position: "relative" }}>
                                                {row.id}{unread > 0 && <div className="availabledot" />}
                                            </TableCell>
                                            <TableCell> {row.ticket} </TableCell>
                                            <TableCell>
                                                <div>
                                                    {row?.agent?.username}<br />
                                                    {row?.agent?.phone}<br />
                                                </div>
                                            </TableCell>
                                            <TableCell style={{ fontWeight: "bolder", borderRadius: "20%", color: getissuecolor(row.status) }} >  {row.status} </TableCell>
                                            <TableCell>{formatDate(row.created_at)} </TableCell>
                                            <TableCell><Clientmessages messagecounter={messagecounter} conversationid={row.id} clientid={row.messages[0].senderid} /></TableCell>
                                            <TableCell sx={{ fontSize: 10, cursor: "pointer" }}>
                                                <PopupState variant="popover" popupId="demo-popup-menu">
                                                    {(popupState) => (
                                                        <React.Fragment>
                                                            <MoreHorizOutlinedIcon {...bindTrigger(popupState)} />
                                                            <Menu {...bindMenu(popupState)}>
                                                                {user.type !== 'Agent' &&
                                                                    <MenuItem sx={{ fontSize: 12 }} onClick={() => handleMenuItemClick(popupState, () => {
                                                                        setshowassignagent(true)
                                                                        setiteminplay(row)
                                                                    })}> Assign agent</MenuItem>}
                                                                <MenuItem sx={{ fontSize: 12 }} onClick={() => handleMenuItemClick(popupState, () => {
                                                                    setshowmarkissue(true)
                                                                    setiteminplay(row)
                                                                })}> Mark as resolved</MenuItem>
                                                            </Menu>
                                                        </React.Fragment>
                                                    )}
                                                </PopupState>
                                            </TableCell>
                                        </TableRow>)
                                })}
                                {emptyRows > 0 && (
                                    <TableRow style={{ height: 53 * emptyRows }}>
                                        <TableCell colSpan={6} />
                                    </TableRow>
                                )}
                            </TableBody>
                            {nodata && <p align="middle">No data</p>}
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                        colSpan={12}
                                        count={displayedconversations.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            inputProps: {
                                                'aria-label': 'rows per page',
                                            },
                                            native: true,
                                        }}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActions}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                </div>
            </Container>
        </div>
    )
}

export default Conversations
